import { Api, LinkGooglePayRequest } from 'vopay';
import axios from 'axios';
import vopayApi from '../../services/api.config';

type HookProps = {
  api: Api;
};

function useGooglePay({ api }: HookProps) {
  const source = axios.CancelToken.source();

  function linkGooglePay(req: LinkGooglePayRequest) {
    return api.linkGooglePay(req, source);
  }

  return {
    linkGooglePay,
  };
}

export default vopayApi.withApiHook<HookProps, ReturnType<typeof useGooglePay>>(useGooglePay);
